export default "__VITE_ASSET__DSTAn8Au__"